import { defineComponent as m, ref as c, onServerPrefetch as v, onMounted as h, watch as s, h as o } from "vue";
import { extractRootHtmlElement as d } from "@scalar-org/vue-render";
import { fetchAsset as y } from "./resolveAndFetchIcon.js";
import { resolveLibraryIcon as g } from "../libraries/index.js";
function w(e) {
  e.target instanceof HTMLElement && (e.target.style.visibility = "hidden");
}
function l(e) {
  const r = g(e);
  return r || e;
}
const M = m({
  props: ["src", "title", "mask"],
  setup(e) {
    const r = typeof e.src == "object" ? e.src.src : e.src || "", n = c(l(r)), a = c();
    function u(t) {
      const f = typeof t == "object" ? t.src : t;
      n.value = l(f);
    }
    async function i(t) {
      a.value = await y(t);
    }
    return v(async () => await i(n.value)), h(async () => !a.value && await i(n.value)), s(() => e.src, u), s(n, i), () => {
      if (a.value) {
        const t = d(a.value);
        if (t.tagName === "svg")
          return o(t.tagName, {
            ...t.properties,
            width: e.size,
            height: e.size,
            class: { ...t.properties.class, ...e.classes },
            innerHTML: t.innerHTML
          });
      }
      return o("img", {
        // Only render the URL (props.src might be an icon key)
        src: n.value,
        alt: e.title,
        width: e.size,
        height: e.size,
        style: "object-fit: contain;",
        class: e.classes,
        onError: w
      });
    };
  }
});
export {
  M as GuideIcon
};
